export default __webpack_public_path__ + "static/media/sunny-galaxy.5f78ec2f9439934c757f5a1a452de95e.svg";